import React from 'react';
import DataTableActionButton from "./data-table-action-button";

export default function DataTableActions( {row, actions=[], className='', ...props} ){
  return (<>
    <div className="d-flex align-items-center gap-1">
      {actions && actions.map((action,i)=>{
          return <DataTableActionButton
            key={i}
            onClick={(e)=>action.action(row, e)}
            icon={action.icon}
            title={action.title}
            className={action.className}
          />
        })}
    </div>
  </>);
}
